import * as React from 'react';
import { Button as ButtonUI } from '@/components/ui/button';
import { Tooltip, TooltipTrigger, TooltipContent } from '@/components/ui/tooltip';
import { cn } from '@/lib/utils';
import { LucideIcon } from './LucideIcon';
import type { Button as Interface } from '../../design/components';

export const Button: React.FC<Interface> = ({
  name, description, hidden, disabled, loading, onClick
}) => {
  const content = (
    <>
      {loading && <LucideIcon name="Loader2" size="small" className="animate-spin mr-1" />}
      {name}
    </>
  );

  if (!description) {
    return (
      <ButtonUI
        type="button"
        variant="outline"
        disabled={disabled || loading}
        onClick={onClick}
        className={cn(hidden && 'hidden')}
      >
        {content}
      </ButtonUI>
    );
  }

  return (
    <Tooltip>
      <TooltipTrigger asChild>
        <ButtonUI
          type="button"
          variant="outline"
          disabled={disabled || loading}
          onClick={onClick}
          className={cn(hidden && 'hidden')}
        >
          {content}
        </ButtonUI>
      </TooltipTrigger>
      <TooltipContent>{description}</TooltipContent>
    </Tooltip>
  );
};
